<template>
  <div class="flex justify-between items-end gap-3">
    <div class="text-sm font-bold text-gray-900">
      <div class="text-sm font-semibold text-gray-600 flex items-center gap-1">
        Страховка от повреждений
        <button
          class="text-blue-500"
          @click="$emit('insurance-info')"
        >
          <IconQuestionCircle class="size-5 text-blue-500" />
        </button>
      </div>
      <div>
        <span :class="insuranceEnabled ? 'text-gray-900' : 'text-gray-600'">
          {{ insurancePrice.toLocaleString($i18n.locale) }}&nbsp;₽&nbsp;×&nbsp;{{ insuranceDays }} {{ $t('common.day', insuranceDays) }} =
        </span>
        <span :class="insuranceEnabled ? 'text-green-500' : 'text-gray-600'">
          {{ insuranceTotalPrice.toLocaleString($i18n.locale) }}&nbsp;₽
        </span>
      </div>
    </div>
    <RmToggleButton
      :value="insuranceEnabled"
      :sync="true"
      :color="{ checked: '#CF243D', unchecked: '#C7CDD8' }"
      @change="$emit('insurance-change', $event)"
    />
  </div>
</template>

<script>
import IconQuestionCircle from '~/assets/svg/ui/question-circle.svg?component';
import RmToggleButton from '~/components/shared/rm_toggle_button.vue';

export default {
  components: {
    IconQuestionCircle,
    RmToggleButton,
  },
  props: {
    insuranceEnabled: {
      type: Boolean,
      default: false,
    },
    insurancePrice: {
      type: Number,
      default: 0,
    },
    insuranceDays: {
      type: Number,
      default: 1,
    },
    insuranceTotalPrice: {
      type: Number,
      default: 0,
    },
    currencyChar: {
      type: String,
      default: '₽',
    },
  },
  emits: ['insurance-info', 'insurance-change'],
}
</script>
